var esus = {
	"price-platform": {
	unit: "unidad",
	"setup-fee": "cargo de configuración",
	"includes-setup-fee": "Incluye cargo de configuración",
	"no-setup-fee": "Sin cargo de configuración",
	"no-minimum-quantity": {
		value: "Sin cantidad mínima",
		_context: "Max length 25"
	},
	"minimum-quantity": {
		value: "Cantidad mínima: {{0}}",
		_context: "Max length 25"
	},
	"minimum-quantity-units": "Mínimo {{0}} unidades",
	"volume-discount": {
		value: "{{0}}% de descuento por volumen",
		length: 50,
		_context: "Do not use 'de' in Spanish => it should be {{0}} % descuento por volumen"
	},
	"volume-discount-sale": "{{0}}% de descuento por volumen + Oferta",
	"price-suffix": {
		total: "total"
	},
	"delivery-not-included": "Envío no incluido",
	"tariff-surcharge": "Podría aplicar un recargo de aranceles",
	"tariff-surcharge-popover": "Este producto se ve afectado por los nuevos aranceles para los productos de China y un recargo podría aplicarse al finalizar la compra. Si desea encontrar otras opciones, llame al (866) 507-7454.",
	"tariff-surcharge-aria-label": "Información emergente sobre aranceles"
}
};

export { esus as default };
//# sourceMappingURL=src-localization-texts-es-us.json.js.map
